
import atlas from '@/components/atlas.vue';
import news from '@/components/news.vue';
import discussion from '@/components/discussion.vue';
import course from '@/components/course.vue';
import activity from '@/components/activity.vue';
export default {
    name: 'collected',
    // props: ['source'],
    components: { atlas, news, discussion, course, activity },
    data() {
        return {
            source: {
                favorite: {

                }
            },//数据
            news: {}, // 收藏咨询
            discussion: {},// 收藏帖子
            courses: {},  // 收藏教程
            events: {}, // 收藏活动
            loading: true,
            hot_type: 1,
            currentPage: 1,
            total: 0,
            pageSize: 0,
        }
    },
    watch: {
        hot_type(val) {
            // this.source = {},
            // this.news = {},
            // this.discussion = {},
            // this.courses = {},
            // this.events = {},
            this.source = this.news = this.discussion = this.courses = this.events = ''
            this.hot_type = val
            this.currentPage = 1
            switch (val) {
                case 1:
                    this.getUserInfo(val)
                    break;
                case 3:
                    this.getUserInfoNews(val)
                    break;
                case 9:
                    this.getUserInfoDiscussion(val)
                    break;
                case 10:
                    this.getUserInfoCourses(val)
                    break;
                case 5:
                    this.getUserInfoEvents(val)
                    break;
                default:
                    break;
            }
        }
    },
    mounted() {
        this.getUserInfo()
        // this.getUserInfoHot()
        // this.getUserInfoNews()
    },
    methods: {
        async getUserInfo(type = 1, page = 1) {
            this.loading = true
            // const res = await $global.galleryList({ page: query.page == undefined ? 1 : query.page, order_type: query.order_type == undefined ? 2 : query.order_type })
            let res = await this.$global.userInfoCollected({ "page": page, "type": type, 'page_num': 20 })
            // console.log(res, 'res')
            if (res.code = '200') {
                this.source = res.data || []
                this.total = res.data.favorite.total
                this.pageSize = res.data.favorite.per_page
            }
            this.loading = false
        },
        handleCurrentChange(val) {
            console.log(val);
            switch (this.hot_type) {
                case 1:
                    this.currentPage = val
                    this.getUserInfo(this.hot_type, val)
                    break;
                case 3:
                    this.currentPage = val
                    this.getUserInfoNews(this.hot_type, val)
                    break;
                case 9:
                    this.currentPage = val
                    this.getUserInfoDiscussion(this.hot_type, val)
                    break;
                case 10:
                    this.currentPage = val
                    this.getUserInfoCourses(this.hot_type, val)
                    break;
                case 5:
                    this.currentPage = val
                    this.getUserInfoEvents(this.hot_type, val)
                    break;
                default:
                    break;
            }
        },
        // 获取收藏咨询
        async getUserInfoNews(type = 3, page = 1) {
            this.loading = true
            let res = await this.$global.userInfoNews({ "page": page, "type": type, 'page_num': 20 })
            if (res.code = '200') {
                this.news = res.data || []
                this.total = res.data.favorite.total
                this.pageSize = res.data.favorite.per_page
            }
            this.loading = false
        },
        // 收藏帖子
        async getUserInfoDiscussion(type = 9, page = 1) {
            this.loading = true
            let res = await this.$global.userInfoCollectDiscussion({ "page": page, "type": type, 'page_num': 20 })
            // console.log(res);
            // console.log(188);
            res.code = '200' ? this.discussion = res.data : []
            this.loading = false
        },
        // 收藏教程
        async getUserInfoCourses(type = 10, page = 1) {
            this.loading = true
            let res = await this.$global.userInfoCourses({ "page": page, "type": type, 'page_num': 20 })
            console.log(res)
            res.code = '200' ? this.courses = res.data : []
            this.loading = false
        },
        // 收藏活动
        async getUserInfoEvents(type = 5, page = 1) {
            this.loading = true
            let res = await this.$global.userInfoCollectActivity({ "page": page, "type": type, 'page_num': 20 })
            res.code = '200' ? this.events = res.data : []
            this.loading = false
        }
        // async getUserInfoHot() {
        //     let res = await this.$global.userInfo({ "page": "1", "order_type": 2 })
        //     console.log(res, 'res')
        //     res.code = '200' ? this.sourceHot = res.data : []
        // },
    }
}
